import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { jwtDecode } from 'jwt-decode';
import { SessionContext } from '#client/contexts/SessionContext.jsx';

const TokenHandler = () => {
    const { login, isAuthenticated } = useContext(SessionContext);
    const navigate = useNavigate();

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const token = params.get('token');

        if (token) {
            try {
                // SessionID for Staff, AccessToken for Customers
                const decoded = jwtDecode(token);
                const sessionId = decoded.sessionId;
                const sessionExpires = decoded.expires;
                const accessToken = decoded.accessToken;
                const customerId = decoded.customerId;

                if (sessionId) {
                    login({ sessionId, sessionExpires });
                } else if (accessToken) {
                    login({ accessToken, customerId });
                    navigate('/voucher-dashboard', { viewTransition: true });
                } else {
                    navigate('/'); // Token missing either sessionId or accessToken
                }
            } catch (err) {
                console.error('Invalid token:', err);
                navigate('/');
            }
        }
    }, [login, navigate, isAuthenticated]);

    useEffect(() => {
        // Only navigate after isAuthenticated is true
        if (isAuthenticated) {
            const returnTo = localStorage.getItem('returnTo');
            if (returnTo) {
                localStorage.removeItem('returnTo');
                navigate(returnTo, { viewTransition: true });
                return;
            }
            navigate('/dashboard', { viewTransition: true });
        }
    }, [isAuthenticated, navigate]);
    return <p>Processing login...</p>;
};

export default TokenHandler;
